/**
 * Removes duplicate objects from an array based on a key or set of keys
 * 
 * @param {Array} array - The array of objects to process
 * @param {String|Array} keys - Property name(s) to use for comparison
 * @return {Array} A new array with duplicates removed
 */
function removeDuplicateObjects(array, keys) {
    // Convert keys parameter to array if it's a string
    const compareKeys = Array.isArray(keys) ? keys : [keys];
    
    // Map to store unique keys
    const seen = new Map();
    
    return array.filter(item => {
        // Create a unique key based on specified properties
        const key = compareKeys.map(k => item[k]).join('|');
      
        // If we haven't seen this key before, keep the item
        if(!seen.has(key)) {
            seen.set(key, true);
            return true;
        }
      
        // Otherwise filter it out
        return false;
    });
}
  
export default removeDuplicateObjects;